import { render, staticRenderFns } from "./NewAvailabilitySwitchSection.vue?vue&type=template&id=16348cd4&scoped=true"
import script from "./NewAvailabilitySwitchSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewAvailabilitySwitchSection.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./NewAvailabilitySwitchSection.vue?vue&type=style&index=0&id=16348cd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16348cd4",
  null
  
)

export default component.exports